import _isEmpty from 'lodash/isEmpty';
import _isString from 'lodash/isString';
import _isBoolean from 'lodash/isBoolean';
import _isDate from 'lodash/isDate';
import _isNumber from 'lodash/isNumber';

export const validateRequire = (value, checkKey) => {
    if (_isString(value)) {
        return !value.trim() ? 'form.field_must_fill' : '';
    }
    if (_isBoolean(value)) {
        return value ? '' : 'form.field_must_fill';
    }
    if (_isDate(value) || _isNumber(value)) {
        return '';
    }

    // array object 都是 for 選項裡面會出現 空的label 所以需要驗證
    if (Array.isArray(value)) {
        if (checkKey) {
            return value.some(item => !item[checkKey]) ? 'form.field_must_fill' : '';
        }
    }

    if (typeof value === 'object' && value !== null) {
        if (checkKey) {
            //針對是不是file 欄位，如果是file 欄位，則不進行驗證
            if (value instanceof File) {
                return '';
            }
            return !value[checkKey] ? 'form.field_must_fill' : '';
        }
    }

    return _isEmpty(value) ? 'form.field_must_fill' : '';
};

export const validateEmail = email => {
    if (email.trim()) {
        const rule = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return rule.test(email.toLowerCase()) ? '' : `form.field_email_invaild`;
    }
    return '';
};

export const validateLength = value => {
    return value.length > 50 ? 'form.field_length_limit' : '';
};

export const validatePhoneNumber = phoneNumber => {
    if (phoneNumber.trim()) {
        const rule = /^[0-9()*+\s\-\x#\uFF0A\uFF0B\uFF0D\uFF03]+$/;
        return rule.test(phoneNumber) ? '' : `form.field_phone_invaild`;
    }
    return '';
};

export const validateDate = date => {
    if (!date) {
        return false;
    }

    try {
        return !isInvalidDate(date) ? '' : 'form.field_format_error';
    } catch (error) {
        return 'form.field_format_error';
    }
};

export function isInvalidDate(date) {
    date = new Date(date);
    return Number.isNaN(date.getTime());
}
